import { ScaleType, Scale, Note } from "@tonaljs/tonal";

const keys = ['C', 'C#', 'D', 'D#', 'E', 'F', 'F#', 'G', 'G#', 'A', 'Bb', 'B'];
const allScales = ScaleType.all().flatMap(scaleDef => keys.map(keyName => Scale.get(`${keyName} ${scaleDef.name}`))).map(scale => ({...scale, notesAbstractMidi: new Set(scale.notes.map(noteName => Note.get(`${noteName}0`).midi).sort())}));

export { allScales };
